import type { OrgRoleId } from "@clovis/server/src/app/domain/org/role";
import type { ProjectRoleId } from "@clovis/server/src/app/domain/project/role";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { getI18nOrgRole } from "~/config/users-rights-permissions/org";
import { getI18nProjectRole } from "~/config/users-rights-permissions/project";
import { Text } from "~/design-system/Text";

type RoleTranslationProps = {
  role: OrgRoleId | ProjectRoleId;
  type: "ORG" | "PROJECT";
};

function RoleTranslation(props: RoleTranslationProps) {
  const { t } = useTranslation();

  if (props.type === "ORG") {
    return <Text>{getI18nOrgRole(props.role as OrgRoleId, t)}</Text>;
  }
  if (props.type === "PROJECT") {
    return <Text>{getI18nProjectRole(props.role as ProjectRoleId, t)}</Text>;
  }

  return null;
}

export { RoleTranslation };
